
import React from "react";
import {
    Box,
    Typography,
    Stack,
    Link,
    Divider,
    Button,
    Container,
    Grid,
} from "@mui/material";

import SportsEsportsIcon from "@mui/icons-material/SportsEsports";
import FacebookIcon from "@mui/icons-material/Facebook";
import PlayArrowRoundedIcon from "@mui/icons-material/PlayArrowRounded";
import DownloadRoundedIcon from "@mui/icons-material/DownloadRounded";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import PeopleAltRoundedIcon from "@mui/icons-material/PeopleAltRounded";
import EmojiEventsRoundedIcon from "@mui/icons-material/EmojiEventsRounded";
import ShieldRoundedIcon from "@mui/icons-material/ShieldRounded";

const Footer = () => {
    return (
        <Box
            component="footer"
            sx={{
                background:
                    "radial-gradient(circle at 50% 0%, rgba(255,65,20,0.12), transparent 30%), radial-gradient(circle at 0% 55%, rgba(190,35,10,0.08), transparent 30%), linear-gradient(180deg, #050505 0%, #0b0706 45%, #030303 100%)",
                pt: { xs: 6, md: 10 },
                pb: 3,
                position: "relative",
                overflow: "hidden",
                color: "#fff",

                "&:before": {
                    content: '""',
                    position: "absolute",
                    top: 0,
                    left: "50%",
                    transform: "translateX(-50%)",
                    width: "75%",
                    height: "2px",
                    background:
                        "linear-gradient(90deg, transparent, #7d1d0b, #ff5420, #ff9a4d, #ff5420, #7d1d0b, transparent)",
                    boxShadow:
                        "0 0 25px rgba(255,84,32,0.35)",
                },

                "&:after": {
                    content: '""',
                    position: "absolute",
                    bottom: 0,
                    left: 0,
                    width: "100%",
                    height: "220px",
                    background:
                        "linear-gradient(to top, rgba(255,62,20,0.045), transparent)",
                    pointerEvents: "none",
                },
            }}
        >
            {/* =====================================================
                AMBIENT FIRE GLOW
            ====================================================== */}

            <Box
                sx={{
                    position: "absolute",
                    top: -160,
                    left: -160,
                    width: 430,
                    height: 430,
                    borderRadius: "50%",
                    background:
                        "rgba(255,65,20,0.12)",
                    filter: "blur(140px)",
                    pointerEvents: "none",
                }}
            />

            <Box
                sx={{
                    position: "absolute",
                    top: 180,
                    right: -220,
                    width: 500,
                    height: 500,
                    borderRadius: "50%",
                    background:
                        "rgba(190,35,10,0.10)",
                    filter: "blur(150px)",
                    pointerEvents: "none",
                }}
            />

            <Box
                sx={{
                    position: "absolute",
                    bottom: -220,
                    left: "38%",
                    width: 500,
                    height: 500,
                    borderRadius: "50%",
                    background:
                        "rgba(255,90,35,0.045)",
                    filter: "blur(150px)",
                    pointerEvents: "none",
                }}
            />

            {/* =====================================================
                DECORATIVE FIRE LINE
            ====================================================== */}

            <Box
                sx={{
                    position: "absolute",
                    top: 42,
                    left: "50%",
                    transform: "translateX(-50%)",
                    width: { xs: "75%", md: "460px" },
                    height: "1px",
                    background:
                        "linear-gradient(90deg, transparent, rgba(255,84,32,0.35), transparent)",
                }}
            />

            <Container
                maxWidth="xl"
                sx={{
                    position: "relative",
                    zIndex: 2,
                }}
            >

                {/* =====================================================
                    MAIN CTA
                ====================================================== */}

                <Box
                    sx={{
                        position: "relative",
                        background:
                            "linear-gradient(135deg, rgba(23,10,7,0.98), rgba(8,8,8,0.98) 60%, rgba(20,7,4,0.98))",
                        borderRadius: {
                            xs: "22px",
                            md: "28px",
                        },
                        p: {
                            xs: 3,
                            sm: 4,
                            md: 6,
                        },
                        mb: {
                            xs: 6,
                            md: 9,
                        },

                        border:
                            "1px solid rgba(255,84,32,0.22)",

                        boxShadow:
                            "0 30px 90px rgba(0,0,0,0.72), inset 0 1px 0 rgba(255,255,255,0.025)",

                        overflow: "hidden",

                        "&:before": {
                            content: '""',
                            position: "absolute",
                            top: 0,
                            left: 0,
                            width: "100%",
                            height: "3px",
                            background:
                                "linear-gradient(90deg, transparent, #8e1d0b, #ff5420, #ff9a4d, #ff5420, #8e1d0b, transparent)",
                            boxShadow:
                                "0 0 20px rgba(255,84,32,0.35)",
                        },

                        "&:after": {
                            content: '""',
                            position: "absolute",
                            right: -120,
                            top: -180,
                            width: 420,
                            height: 420,
                            borderRadius: "50%",
                            border:
                                "1px solid rgba(255,84,32,0.08)",
                            boxShadow:
                                "0 0 100px rgba(255,84,32,0.05)",
                        },
                    }}
                >
                    <Grid
                        container
                        spacing={5}
                        alignItems="center"
                    >

                        {/* CTA LEFT */}

                        <Grid item xs={12} md={5}>

                            <Stack
                                direction="row"
                                spacing={1}
                                alignItems="center"
                                sx={{ mb: 1.5 }}
                            >
                                <Box
                                    sx={{
                                        width: 28,
                                        height: 2,
                                        background:
                                            "linear-gradient(90deg, #ff5420, transparent)",
                                    }}
                                />

                                <Typography
                                    sx={{
                                        color: "#ff7135",
                                        fontWeight: 900,
                                        letterSpacing: "3px",
                                        fontSize: "10px",
                                        textTransform:
                                            "uppercase",
                                    }}
                                >
                                    VEX CONQUER
                                </Typography>
                            </Stack>

                            <Typography
                                sx={{
                                    fontSize: {
                                        xs: "2rem",
                                        sm: "2.4rem",
                                        md: "3rem",
                                    },
                                    fontWeight: 900,
                                    lineHeight: 1.05,
                                    color: "#fff",
                                    mb: 1.5,
                                    letterSpacing: "-1px",
                                }}
                            >
                                YOUR BATTLE.
                                <br />

                                <Box
                                    component="span"
                                    sx={{
                                        background:
                                            "linear-gradient(90deg, #ff4b1f, #ff9a4d, #ff5420)",
                                        WebkitBackgroundClip:
                                            "text",
                                        WebkitTextFillColor:
                                            "transparent",
                                        textShadow:
                                            "0 0 30px rgba(255,84,32,0.12)",
                                    }}
                                >
                                    YOUR LEGACY.
                                </Box>
                            </Typography>

                            <Typography
                                sx={{
                                    color: "#888",
                                    fontSize: "14px",
                                    lineHeight: 1.8,
                                    maxWidth: "500px",
                                    mb: 3.5,
                                }}
                            >
                                Enter the classic world of Vex
                                Conquer. Build your warrior,
                                challenge rival guilds and fight
                                your way to the top.
                            </Typography>

                            <Stack
                                direction={{
                                    xs: "column",
                                    sm: "row",
                                }}
                                spacing={1.5}
                            >

                                {/* PLAY */}

                                <Button
                                    variant="contained"
                                    startIcon={
                                        <PlayArrowRoundedIcon />
                                    }
                                    onClick={() =>
                                        (window.location.href =
                                            "/downloads")
                                    }
                                    sx={{
                                        background:
                                            "linear-gradient(135deg, #ff4b1f, #c72d0d)",
                                        color: "#fff",
                                        borderRadius: "10px",
                                        px: 3.5,
                                        py: 1.45,
                                        fontWeight: 900,
                                        textTransform:
                                            "uppercase",
                                        letterSpacing: "0.5px",

                                        boxShadow:
                                            "0 8px 30px rgba(255,70,25,0.20)",

                                        transition:
                                            "all 0.25s ease",

                                        "&:hover": {
                                            background:
                                                "linear-gradient(135deg, #ff7135, #e53a14)",
                                            transform:
                                                "translateY(-3px)",
                                            boxShadow:
                                                "0 12px 35px rgba(255,70,25,0.32)",
                                        },
                                    }}
                                >
                                    Play Now
                                </Button>

                                {/* DOWNLOAD */}

                                <Button
                                    variant="outlined"
                                    startIcon={
                                        <DownloadRoundedIcon />
                                    }
                                    onClick={() =>
                                        (window.location.href =
                                            "/downloads")
                                    }
                                    sx={{
                                        borderRadius: "10px",
                                        px: 3.5,
                                        py: 1.45,
                                        fontWeight: 800,
                                        textTransform:
                                            "uppercase",
                                        letterSpacing:
                                            "0.5px",

                                        borderColor:
                                            "rgba(255,84,32,0.42)",

                                        color: "#ff7135",

                                        background:
                                            "rgba(255,84,32,0.025)",

                                        transition:
                                            "all 0.25s ease",

                                        "&:hover": {
                                            borderColor:
                                                "#ff5420",
                                            color: "#ff9a4d",
                                            background:
                                                "rgba(255,84,32,0.08)",
                                            transform:
                                                "translateY(-3px)",
                                        },
                                    }}
                                >
                                    Download Client
                                </Button>

                            </Stack>
                        </Grid>

                        {/* RIGHT STATS */}

                        <Grid item xs={12} md={7}>

                            <Grid
                                container
                                spacing={2}
                            >

                                {[
                                    {
                                        icon: (
                                            <EmojiEventsRoundedIcon />
                                        ),
                                        value:
                                            "CLASSIC 5165",
                                        label:
                                            "Vex Conquer",
                                    },
                                    {
                                        icon: (
                                            <PeopleAltRoundedIcon />
                                        ),
                                        value: "130",
                                        label:
                                            "Maximum Level",
                                    },
                                    {
                                        icon: (
                                            <ShieldRoundedIcon />
                                        ),
                                        value: "1ST",
                                        label:
                                            "Reborn System",
                                    },
                                ].map(
                                    (item, index) => (
                                        <Grid
                                            item
                                            xs={12}
                                            sm={4}
                                            key={index}
                                        >
                                            <Box
                                                sx={{
                                                    height:
                                                        "100%",
                                                    minHeight:
                                                        180,
                                                    textAlign:
                                                        "center",
                                                    display:
                                                        "flex",
                                                    flexDirection:
                                                        "column",
                                                    alignItems:
                                                        "center",
                                                    justifyContent:
                                                        "center",
                                                    position:
                                                        "relative",

                                                    borderRadius:
                                                        "18px",

                                                    background:
                                                        "linear-gradient(180deg, rgba(255,255,255,0.035), rgba(255,65,20,0.018))",

                                                    border:
                                                        "1px solid rgba(255,255,255,0.055)",

                                                    transition:
                                                        "all 0.3s ease",

                                                    "&:hover":
                                                        {
                                                            transform:
                                                                "translateY(-6px)",
                                                            borderColor:
                                                                "rgba(255,84,32,0.35)",
                                                            background:
                                                                "linear-gradient(180deg, rgba(255,84,32,0.08), rgba(255,255,255,0.015))",
                                                            boxShadow:
                                                                "0 15px 40px rgba(255,60,20,0.08)",
                                                        },
                                                }}
                                            >

                                                <Box
                                                    sx={{
                                                        width: 62,
                                                        height: 62,
                                                        borderRadius:
                                                            "17px",
                                                        background:
                                                            "linear-gradient(135deg, rgba(255,84,32,0.18), rgba(255,84,32,0.035))",
                                                        border:
                                                            "1px solid rgba(255,84,32,0.20)",
                                                        display:
                                                            "flex",
                                                        alignItems:
                                                            "center",
                                                        justifyContent:
                                                            "center",
                                                        mb: 2,
                                                        color:
                                                            "#ff7135",
                                                        boxShadow:
                                                            "0 8px 25px rgba(0,0,0,0.35)",
                                                    }}
                                                >
                                                    {item.icon}
                                                </Box>

                                                <Typography
                                                    sx={{
                                                        fontSize:
                                                            item.value ===
                                                            "CLASSIC 5165"
                                                                ? "1.15rem"
                                                                : "2rem",
                                                        fontWeight:
                                                            900,
                                                        color:
                                                            "#fff",
                                                        lineHeight:
                                                            1.2,
                                                        mb: 0.5,
                                                    }}
                                                >
                                                    {
                                                        item.value
                                                    }
                                                </Typography>

                                                <Typography
                                                    sx={{
                                                        color:
                                                            "#777",
                                                        fontWeight:
                                                            600,
                                                        fontSize:
                                                            "11px",
                                                        letterSpacing:
                                                            "1px",
                                                        textTransform:
                                                            "uppercase",
                                                    }}
                                                >
                                                    {
                                                        item.label
                                                    }
                                                </Typography>

                                            </Box>
                                        </Grid>
                                    )
                                )}

                            </Grid>
                        </Grid>
                    </Grid>
                </Box>

                {/* =====================================================
                    VEX FEATURES
                ====================================================== */}

                <Box
                    sx={{
                        mb: {
                            xs: 6,
                            md: 8,
                        },
                    }}
                >

                    <Grid
                        container
                        spacing={1.5}
                    >

                        {[
                            "LEVEL 130",
                            "MAX +9",
                            "BLESS -5",
                            "1ST REBORN",
                            "CLASSIC PVP",
                            "GUILD WARS",
                            "CPS SYSTEM",
                            "NO NINJA",
                            "NO MONK",
                        ].map(
                            (feature, index) => (
                                <Grid
                                    item
                                    xs={6}
                                    sm={4}
                                    md={2.66}
                                    key={index}
                                >
                                    <Box
                                        sx={{
                                            py: 1.3,
                                            px: 1,
                                            textAlign:
                                                "center",
                                            borderRadius:
                                                "8px",
                                            border:
                                                "1px solid rgba(255,255,255,0.045)",
                                            background:
                                                "rgba(255,255,255,0.015)",
                                            color:
                                                "#777",
                                            fontSize:
                                                "10px",
                                            fontWeight:
                                                800,
                                            letterSpacing:
                                                "1px",
                                            transition:
                                                "all .25s ease",

                                            "&:hover":
                                                {
                                                    color:
                                                        "#ff7135",
                                                    borderColor:
                                                        "rgba(255,84,32,0.25)",
                                                    background:
                                                        "rgba(255,84,32,0.035)",
                                                },
                                        }}
                                    >
                                        {feature}
                                    </Box>
                                </Grid>
                            )
                        )}

                    </Grid>

                </Box>

                {/* =====================================================
                    MAIN FOOTER
                ====================================================== */}

                <Grid
                    container
                    spacing={{
                        xs: 4,
                        md: 6,
                    }}
                    sx={{
                        mb: {
                            xs: 5,
                            md: 7,
                        },
                    }}
                >

                    {/* BRAND */}

                    <Grid item xs={12} md={5}>

                        <Typography
                            sx={{
                                fontSize: {
                                    xs: "2rem",
                                    md: "2.5rem",
                                },
                                fontWeight: 900,
                                color: "#fff",
                                mb: 1.5,
                                letterSpacing:
                                    "-1px",
                            }}
                        >
                            <Box
                                component="span"
                                sx={{
                                    background:
                                        "linear-gradient(90deg, #ff4b1f, #ff9a4d)",
                                    WebkitBackgroundClip:
                                        "text",
                                    WebkitTextFillColor:
                                        "transparent",
                                }}
                            >
                                Vex
                            </Box>{" "}
                            Conquer
                        </Typography>

                        <Box
                            sx={{
                                width: 65,
                                height: 3,
                                borderRadius: "10px",
                                background:
                                    "linear-gradient(90deg, #ff5420, transparent)",
                                mb: 2.5,
                                boxShadow:
                                    "0 0 12px rgba(255,84,32,0.3)",
                            }}
                        />

                        <Typography
                            sx={{
                                color: "#858585",
                                lineHeight: 1.9,
                                maxWidth:
                                    "500px",
                                fontWeight: 500,
                                fontSize: "14px",
                            }}
                        >
                            Vex Conquer is a classic
                            5165 Conquer server
                            built around old-school
                            PvP, guild wars,
                            progression and
                            competitive gameplay.
                        </Typography>

                        {/* SERVER TAGS */}

                        <Stack
                            direction="row"
                            spacing={1}
                            flexWrap="wrap"
                            useFlexGap
                            mt={2.5}
                        >
                            {[
                                "5165",
                                "CLASSIC",
                                "PVP",
                                "GUILD WAR",
                            ].map(
                                (tag) => (
                                    <Box
                                        key={tag}
                                        sx={{
                                            px: 1.4,
                                            py: 0.65,
                                            borderRadius:
                                                "6px",
                                            border:
                                                "1px solid rgba(255,84,32,0.14)",
                                            background:
                                                "rgba(255,84,32,0.035)",
                                            color:
                                                "#9a9a9a",
                                            fontSize:
                                                "9px",
                                            fontWeight:
                                                800,
                                            letterSpacing:
                                                "1px",
                                        }}
                                    >
                                        {tag}
                                    </Box>
                                )
                            )}
                        </Stack>

                        {/* SOCIALS */}

                        <Stack
                            direction="row"
                            spacing={1.5}
                            mt={3.5}
                        >

                            <Box
                                component="a"
                                href="https://discord.gg/GusbbTUdRQ"
                                target="_blank"
                                rel="noopener noreferrer"
                                sx={{
                                    width: 48,
                                    height: 48,
                                    borderRadius:
                                        "12px",
                                    background:
                                        "linear-gradient(145deg, #151515, #090909)",
                                    border:
                                        "1px solid rgba(255,84,32,0.10)",
                                    display:
                                        "flex",
                                    alignItems:
                                        "center",
                                    justifyContent:
                                        "center",
                                    color:
                                        "#ff7135",
                                    textDecoration:
                                        "none",
                                    transition:
                                        "all .25s ease",

                                    "&:hover": {
                                        transform:
                                            "translateY(-4px)",
                                        borderColor:
                                            "rgba(255,84,32,0.45)",
                                        background:
                                            "rgba(255,84,32,0.08)",
                                        boxShadow:
                                            "0 10px 30px rgba(255,60,20,0.15)",
                                    },
                                }}
                            >
                                <SportsEsportsIcon />
                            </Box>

                            <Box
                                component="a"
                                href="https://www.facebook.com/VexConquer2026"
                                target="_blank"
                                rel="noopener noreferrer"
                                sx={{
                                    width: 48,
                                    height: 48,
                                    borderRadius:
                                        "12px",
                                    background:
                                        "linear-gradient(145deg, #151515, #090909)",
                                    border:
                                        "1px solid rgba(255,255,255,0.06)",
                                    display:
                                        "flex",
                                    alignItems:
                                        "center",
                                    justifyContent:
                                        "center",
                                    color:
                                        "#ff7135",
                                    textDecoration:
                                        "none",
                                    transition:
                                        "all .25s ease",

                                    "&:hover": {
                                        transform:
                                            "translateY(-4px)",
                                        borderColor:
                                            "rgba(255,84,32,0.45)",
                                        background:
                                            "rgba(255,84,32,0.08)",
                                        boxShadow:
                                            "0 10px 30px rgba(255,60,20,0.15)",
                                    },
                                }}
                            >
                                <FacebookIcon />
                            </Box>

                        </Stack>
                    </Grid>

                    {/* QUICK LINKS */}

                    <Grid
                        item
                        xs={6}
                        sm={4}
                        md={2}
                    >

                        <Typography
                            sx={{
                                fontWeight: 900,
                                mb: 2.5,
                                color: "#fff",
                                fontSize: "11px",
                                letterSpacing:
                                    "2px",
                            }}
                        >
                            VEX NAVIGATION
                        </Typography>

                        <Stack spacing={1.5}>

                            {[
                                ["/", "Home"],
                                [
                                    "/downloads",
                                    "Download",
                                ],
                                [
                                    "/ranks",
                                    "Rankings",
                                ],
                                [
                                    "/schedules",
                                    "Events",
                                ],
                            ].map(
                                ([url, text]) => (
                                    <Link
                                        key={text}
                                        href={url}
                                        underline="none"
                                        sx={{
                                            color:
                                                "#777",
                                            fontSize:
                                                "13px",
                                            fontWeight:
                                                500,
                                            transition:
                                                "all .2s ease",

                                            "&:hover":
                                                {
                                                    color:
                                                        "#ff7135",
                                                    transform:
                                                        "translateX(5px)",
                                                },
                                        }}
                                    >
                                        {text}
                                    </Link>
                                )
                            )}

                        </Stack>
                    </Grid>

                    {/* COMMUNITY */}

                    <Grid
                        item
                        xs={6}
                        sm={4}
                        md={2}
                    >

                        <Typography
                            sx={{
                                fontWeight: 900,
                                mb: 2.5,
                                color: "#fff",
                                fontSize: "11px",
                                letterSpacing:
                                    "2px",
                            }}
                        >
                            COMMUNITY
                        </Typography>

                        <Stack spacing={1.5}>

                            <Link
                                href="https://discord.gg/GusbbTUdRQ"
                                target="_blank"
                                underline="none"
                                sx={{
                                    color:
                                        "#777",
                                    fontSize:
                                        "13px",
                                    transition:
                                        "all .2s ease",

                                    "&:hover": {
                                        color:
                                            "#ff7135",
                                        transform:
                                            "translateX(5px)",
                                    },
                                }}
                            >
                                Discord
                            </Link>

                            <Link
                                href="https://www.facebook.com/VexConquer2026"
                                target="_blank"
                                underline="none"
                                sx={{
                                    color:
                                        "#777",
                                    fontSize:
                                        "13px",
                                    transition:
                                        "all .2s ease",

                                    "&:hover": {
                                        color:
                                            "#ff7135",
                                        transform:
                                            "translateX(5px)",
                                    },
                                }}
                            >
                                Facebook
                            </Link>

                            <Link
                                href="/wiki"
                                underline="none"
                                sx={{
                                    color:
                                        "#777",
                                    fontSize:
                                        "13px",
                                    transition:
                                        "all .2s ease",

                                    "&:hover": {
                                        color:
                                            "#ff7135",
                                        transform:
                                            "translateX(5px)",
                                    },
                                }}
                            >
                                Wiki / Guides
                            </Link>

                        </Stack>
                    </Grid>

                    {/* SERVER */}

                    <Grid
                        item
                        xs={12}
                        sm={4}
                        md={3}
                    >

                        <Typography
                            sx={{
                                fontWeight: 900,
                                mb: 2.5,
                                color: "#fff",
                                fontSize: "11px",
                                letterSpacing:
                                    "2px",
                            }}
                        >
                            SERVER
                        </Typography>

                        <Stack spacing={1.4}>

                            {[
                                [
                                    "Version",
                                    "5165 Classic",
                                ],
                                [
                                    "Level Cap",
                                    "130",
                                ],
                                [
                                    "Reborn",
                                    "1st Reborn",
                                ],
                                [
                                    "Max Plus",
                                    "+9",
                                ],
                            ].map(
                                ([label, value]) => (
                                    <Box
                                        key={label}
                                        sx={{
                                            display:
                                                "flex",
                                            justifyContent:
                                                "space-between",
                                            gap: 2,
                                            borderBottom:
                                                "1px solid rgba(255,255,255,0.04)",
                                            pb: 1,
                                        }}
                                    >
                                        <Typography
                                            sx={{
                                                color:
                                                    "#666",
                                                fontSize:
                                                    "12px",
                                            }}
                                        >
                                            {label}
                                        </Typography>

                                        <Typography
                                            sx={{
                                                color:
                                                    "#b5b5b5",
                                                fontSize:
                                                    "12px",
                                                fontWeight:
                                                    700,
                                            }}
                                        >
                                            {value}
                                        </Typography>
                                    </Box>
                                )
                            )}

                        </Stack>
                    </Grid>
                </Grid>

                {/* =====================================================
                    BOTTOM
                ====================================================== */}

                <Divider
                    sx={{
                        borderColor:
                            "rgba(255,84,32,0.10)",
                        mb: 3,
                    }}
                />

                <Box
                    sx={{
                        display: "flex",
                        justifyContent:
                            "space-between",
                        alignItems:
                            "center",
                        gap: 2,
                        flexWrap:
                            "wrap",
                    }}
                >

                    <Typography
                        sx={{
                            color: "#505050",
                            fontSize: "11px",
                            fontWeight: 500,
                        }}
                    >
                        � 2026 Vex Conquer. All
                        rights reserved.
                    </Typography>

                    <Typography
                        sx={{
                            color: "#3f3f3f",
                            fontSize: "10px",
                            letterSpacing:
                                "1.5px",
                            textTransform:
                                "uppercase",
                            display: {
                                xs: "none",
                                sm: "block",
                            },
                        }}
                    >
                        Vex Conquer � Classic 5165
                    </Typography>

                    {/* BACK TO TOP */}

                    <Box
                        onClick={() =>
                            window.scrollTo({
                                top: 0,
                                behavior:
                                    "smooth",
                            })
                        }
                        sx={{
                            width: 46,
                            height: 46,
                            borderRadius:
                                "12px",
                            background:
                                "linear-gradient(145deg, #17100e, #090909)",
                            border:
                                "1px solid rgba(255,84,32,0.15)",
                            color:
                                "#ff7135",
                            display:
                                "flex",
                            alignItems:
                                "center",
                            justifyContent:
                                "center",
                            cursor:
                                "pointer",
                            transition:
                                "all .25s ease",

                            "&:hover": {
                                transform:
                                    "translateY(-4px)",
                                background:
                                    "rgba(255,84,32,0.09)",
                                borderColor:
                                    "rgba(255,84,32,0.45)",
                                boxShadow:
                                    "0 8px 30px rgba(255,60,20,0.15)",
                            },
                        }}
                    >
                        <KeyboardArrowUpIcon />
                    </Box>

                </Box>

            </Container>
        </Box>
    );
};

export default Footer;

